import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'columnAlignment',
})
export class ColumnAlignmentPipe implements PipeTransform {
  transform(value: string): string {
    if (value === 'right') {
      return 'end';
    }

    if (value === 'center') {
      return 'center';
    }

    if (value === 'left') {
      return 'start';
    }

    return null;
  }
}
